module.exports = __webpack_public_path__ + "img/security-top-bg.b913a359.png";